/**
 * learn.4klabs.ai — the PARENT portal ("How your child is doing").
 *
 * A no-login preview reached from the Insights tab. It opens a featured sample
 * learner from the same class the teacher dashboard uses. Plain-language, minor-safe,
 * no peer comparison. Driven by mock data shaped exactly like the live signals.
 */

import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useLearnTheme, LearnRoot, LearnTopBar } from '../components/learn/learnShared';
import { ParentPortal } from '../components/learn/insights/ParentPortal';
import { LensTabs, LearnerPicker } from '../components/learn/insights/portalShell';
import { DEMO_CLASS } from '../components/learn/insights/mockData';
import { featuredLearner } from '../components/learn/insights/roleProjections';

export const Route = createFileRoute('/learn/parent')({
  validateSearch: (s: Record<string, unknown>): { learner?: string } => ({ learner: typeof s.learner === 'string' ? s.learner : undefined }),
  component: ParentPortalPage,
});

function ParentPortalPage() {
  const { theme, toggle } = useLearnTheme();
  const { learner: learnerParam } = Route.useSearch();
  const roster = DEMO_CLASS;
  const [learnerId, setLearnerId] = useState(() =>
    (learnerParam && roster.learners.some((l) => l.id === learnerParam)) ? learnerParam : featuredLearner(roster).id);
  const learner = roster.learners.find((l) => l.id === learnerId) ?? featuredLearner(roster);

  return (
    <LearnRoot theme={theme}>
      <LearnTopBar theme={theme} onToggle={toggle}
        right={<div className="flex items-center gap-2"><LensTabs active="parent" learnerId={learnerId} /><LearnerPicker roster={roster} value={learnerId} onChange={setLearnerId} /></div>} />
      <main className="mx-auto max-w-[1240px] px-6 pb-20 pt-6">
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#7C3AED]/30 bg-[#7C3AED]/10 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-[#6D28D9] dark:text-[#B69BF5]">
          <span className="h-1.5 w-1.5 rounded-full bg-current" /> Live preview · sample learner
        </div>
        <ParentPortal roster={roster} learner={learner} />
      </main>
    </LearnRoot>
  );
}
